<template>
  <div>
    <panel title="Wzory procedur">
      <w-table
        entity-type="template"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="add"
        @edit="edit($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania wzorów procedury.',
  getError: 'Wystąpił błąd podczas pobierania danych wzorów procedury.',
  added: 'Dodano wzór procedury.',
  addError: 'Nie udało się dodać wzoru procedury.',
  updated: 'Zaktualizowano dane wzoru procedury.',
  updateError: 'Nie udało się zaktualizować danych wzoru procedury.',
  deleteConfirm: 'Czy na pewno chcesz usunąć wzór procedury?',
  deleted: 'Usunięto wzór procedury.',
  deleteError: 'Nie udało się usunąć wzoru procedury.'
};

// @vuese
// Lista wzorów
// @group template
export default {
  components: { Panel, WTable },
  mixins: [listMixin('template', messages)],
  data: () => ({
    columns: [{ name: 'id', displayName: 'ID' }, { name: 'name', displayName: 'Nazwa', sortable: true }],
    actions: DEFAULT_TABLE_ACTIONS
  }),
  methods: {
    // @vuese
    // Dodawanie
    add() {
      this.$router.push({ name: 'templateAdd' });
    },
    // @vuese
    // Edycja
    edit(templateId) {
      this.$router.push({ name: 'templateEdit', params: { templateId } });
    }
  }
};
</script>